// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingOverlay_root__1EK6Z","spinner":"LoadingOverlay_spinner__m0ZIk"};